import { useState } from "react";
import {
  Box,
  Card,
  CardActions,
  CardMedia,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import { SAVE_RECENTLY_INTERACT_USERS, SEND_TICKETS } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import ShareModule from "../common/ShareModule";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import GroupIcon from "@mui/icons-material/Group";
import ErrorIcon from "@mui/icons-material/Error";
import { setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { BIBlue } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
const ShareTicketModal = (props) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  let currentUserId = loginData?.userInformation?.UserId;
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSendPdfCopy, setIsSendPdfCopy] = useState(false);
  const dispatch = useDispatch();

  const {
    TEXT_EXPIRED_TICKET_ALERT = English?.Tickets?.TEXT_EXPIRED_TICKET_ALERT,
    TEXT_SHARED_TICKET_ALERT = English?.Tickets?.TEXT_SHARED_TICKET_ALERT,
    TEXT_SEND_PDF_COPY = English?.Tickets?.TEXT_SEND_PDF_COPY,
    TEXT_SHARE_TICKETS = English?.Tickets?.TEXT_SHARE_TICKETS,
    TEXT_TICKETS_TO_SHARE = English?.Tickets?.TEXT_TICKETS_TO_SHARE
  } = multiLanguageData?.Tickets || {};

  function handleSendPdfCopy() {
    setIsSendPdfCopy((prevState) => !prevState);
  }

  const handleShareTicket = async () => {
    try {
      setLoading(true);
      if (selectedEmails.length !== 0) {
        const ticketArray = props?.tickets?.map((item) => item.id);
        const emailList = selectedEmails?.map((item) => item.contactEmail);

        const sendTicketObj = {
          Emails: emailList,
          Tickets: ticketArray,
          UserId: currentUserId,
          IsSendPDF: isSendPdfCopy
        };

        const sendTicketResponse = await Postrequestcall(
          SEND_TICKETS,
          sendTicketObj,
          loginData?.accessToken
        );

        if (sendTicketResponse?.data?.message === "OK") {
          const interactionRequests = selectedEmails
            ?.filter((item) => !item.contactId == 0)
            ?.map((item) => ({
              UserId: Number(currentUserId),
              ReturnRecordId: true,
              ReturnRecordError: true,
              SaveList: [
                {
                  Id: 0,
                  UserId: Number(currentUserId),
                  InteractUserId: item.contactId,
                  ModifiedBy: Number(currentUserId),
                  fromScreen: "Resume"
                }
              ]
            }));

          await Promise.all(
            interactionRequests.map((interactionObj) =>
              Postrequestcall(SAVE_RECENTLY_INTERACT_USERS, interactionObj, loginData?.accessToken)
            )
          );
        }
        props?.setFromFlag("viewModalSave");
        props?.fetchUserTicket();
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      setLoading(false);
      console.log("handleShareTicket-> Error When Sharing Tickets: ", error);
    }
  };

  const handleClose = () => {
    props?.close();
    setSelectedEmails([]);
  };

  const isExpired = (expiryDate) => {
    if (expiryDate === "" || expiryDate === null) return;
    const currentDate = new Date();
    const expiry = new Date(expiryDate);
    return expiry < currentDate;
  };

  const handleMessage = (icon) => {
    if (icon === "GroupIcon") {
      let alertObj = {
        showAlert: true,
        text2: TEXT_SHARED_TICKET_ALERT
      };
      dispatch(setShowalert(alertObj));
    } else if (icon === "ErrorIcon") {
      let alertObj = {
        showAlert: true,
        text2: TEXT_EXPIRED_TICKET_ALERT
      };
      dispatch(setShowalert(alertObj));
    }
  };
  return (
    <Modal open={props?.isOpen}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_SHARE_TICKETS}</Typography>
          <Stack direction={"row"}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <IconButton
              loading={loading}
              color="primary"
              onClick={handleShareTicket}
              disabled={selectedEmails.length === 0}>
              <SendIcon />
            </IconButton>
          </Stack>
        </Box>
        <Box maxHeight={"560px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
          <ShareModule
            from="ShareTickets"
            setSelectedEmails={setSelectedEmails}
            selectedEmails={selectedEmails}
          />
          <FormControlLabel
            control={
              <Checkbox
                sx={{ color: BIBlue, ml: 1.5 }}
                checked={isSendPdfCopy}
                onChange={handleSendPdfCopy}
              />
            }
            label={TEXT_SEND_PDF_COPY}
          />
          <Stack spacing={0.5}>
            <Typography variant="body1">{TEXT_TICKETS_TO_SHARE}</Typography>
            <Divider />

            <Box maxHeight={"280px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
              <Grid sx={{ mt: 1 }} container spacing={{ xs: 1.5, md: 2 }}>
                {props?.tickets?.map((ticket, index) => (
                  <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Card
                      key={index.toString()}
                      className="pagelist-content"
                      sx={{
                        backgroundColor: isExpired(ticket.expiry) === true ? "#FABEBE" : ""
                      }}>
                      <CardMedia
                        component="img"
                        height="200"
                        image={ticket?.frontPictureUrl}
                        alt="Front Picture"
                      />
                      <CardActions
                        disableSpacing
                        sx={{ flexDirection: "column", alignItems: "baseline" }}>
                        <Stack
                          direction="row"
                          spacing={0.1}
                          sx={{ justifyContent: "space-between" }}
                          width={"100%"}>
                          <Stack direction={"row"} sx={{ alignItems: "center" }}>
                            <Typography variant="body1" maxWidth={"170px"} noWrap>
                              {ticket?.ticketType}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"} sx={{ alignItems: "center" }}>
                            {isExpired(ticket.expiry) === true && (
                              <IconButton
                                color="secondary"
                                size="small"
                                aria-label="add to favorites"
                                onClick={() => handleMessage("ErrorIcon")}>
                                <ErrorIcon fontSize="small" />
                              </IconButton>
                            )}
                            {ticket.sharedTicketsList?.length !== 0 && (
                              <IconButton
                                color="default"
                                size="small"
                                aria-label="group"
                                onClick={() => handleMessage("GroupIcon")}>
                                <GroupIcon fontSize="small" />
                              </IconButton>
                            )}
                          </Stack>
                        </Stack>
                        <Typography sx={{ pl: 1 }} variant="body1" maxWidth={"250px"} noWrap>
                          {ticket?.issuedBy}
                        </Typography>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};

export default ShareTicketModal;
